import { CONFIGURE_QLLT } from '~/apps/consumer/pages/Quotes/Builder/QuoteDetailPage/FilesTab/QuoteLevelLeadTime/constants'
import {
    RESET_LAST_ACTION_PERFORMED,
    SET_IS_EDIT_PDF_MODE,
    SET_QLLT_SELECTED_OPTION,
} from '~/redux-modules/quote-qllt/constants'

import { ActionType, StateType } from './types'
import {
    SET_QLLT_DATA_LOADING,
    SET_QLLT_DATA_FAILURE,
    SET_QLLT_DATA,
    SET_NEED_BY_DATE_LOADING,
    SET_NEED_BY_DATE_FAILURE,
    SET_COST_AND_LEAD_TIME_LOADING,
    SET_COST_AND_LEAD_TIME_FAILURE,
    SET_COST_AND_LEAD_TIME,
    SET_ALL_BATCH_POST_PROCESS_LOADING,
    GET_ALL_BATCH_POST_PROCESS_FAILURE,
    GET_ALL_BATCH_POST_PROCESS_QUERY_DATA,
    GET_QLLT_SLACK_THREAD_QUERY_FAILURE,
    GET_QLLT_SLACK_THREAD_QUERY_LOADING,
    GET_QLLT_SLACK_THREAD_QUERY_SUCCESS,
    CREATE_SLACK_THREAD_FAILURE,
    CREATE_SLACK_THREAD_LOADING,
    SET_QLLT_CONFIGURE_OPTION,
    SET_PROCESS_CONFIG_TO_QMR,
    UPDATE_PROCESS_CONFIG_DATA,
    GET_PROCESS_DETAILS_FAILURE,
    SET_PROCESS_DETAILS_LOADING,
    RESET_OPTIMIZATION,
    GET_RECOMMENDED_QUANTITY_TO_REDUCE_LEAD_TIME_LOADING,
    GET_RECOMMENDED_QUANTITY_TO_REDUCE_LEAD_TIME_FAILURE,
    SET_RECOMMENDED_QUANTITY_TO_REDUCE_LEAD_TIME,
    REMOVE_ALL_THREADS_FAILURE,
    REMOVE_ALL_THREADS_LOADING,
    BUSINESS_ACCOUNT_FEATURE_QUERY_FAILURE,
    BUSINESS_ACCOUNT_FEATURE_QUERY_LOADING,
    BUSINESS_ACCOUNT_FEATURE_QUERY_SUCCESS,
    SET_BUSINESS_ACCOUNT_FEATURE_FAILURE,
    SET_BUSINESS_ACCOUNT_FEATURE_LOADING,
    SET_LAST_ACTION_PERFORMED,
    SET_3D_MODE,
} from './constants'

export const INIT_STATE: StateType = {
    queries: {
        setNeedByDate: {
            loading: false,
            error: null,
        },
        getQlltData: {
            loading: false,
            error: null,
        },
        getCostAndLeadTime: {
            loading: false,
            error: null,
        },
        getAllBatchPostProcessIdQueryData: {
            loading: false,
            error: null,
        },
        updateProcessConfigs: {
            loading: false,
            error: null,
        },
        getQlltSlackThreadData: {
            loading: false,
            error: null,
        },
        createSlackThread: {
            loading: false,
            error: null,
        },
        recommendedQuantitiesToHitDeliveryDate: {
            loading: false,
            error: null,
        },
        removeAllThreads: {
            loading: false,
            error: null,
        },
        getBusinessAccountFeature: {
            loading: false,
            error: null,
        },
        setCLTBusinessAccountFeature: {
            loading: false,
            error: null,
        },
    },
    data: {},
    batchPostProcessIds: [],
    costAndLeadTimeData: null,
    configureLeadTimeOption: CONFIGURE_QLLT,
    processConfig: {},
    slackThreadUrl: null,
    businessAccountCLTFeature: null,
    recommendedQuantitiesToHitDeliveryDate: [],
    lastActivityPerformed: null,
    isEditPdfMode: false,
    showConfigIn3D: false,
    qlltSelectedOption: null,
}

const reducer = (state = INIT_STATE, action: ActionType) => {
    switch (action.type) {
        case SET_IS_EDIT_PDF_MODE: {
            return {
                ...state,
                isEditPdfMode: action.payload,
            }
        }
        case SET_NEED_BY_DATE_LOADING: {
            return {
                ...state,
                queries: {
                    ...state.queries,
                    setNeedByDate: {
                        loading: action.payload,
                        error: null,
                    },
                },
            }
        }
        case SET_NEED_BY_DATE_FAILURE: {
            return {
                ...state,
                queries: {
                    ...state.queries,
                    setNeedByDate: {
                        loading: false,
                        error: action.payload,
                    },
                },
            }
        }
        case SET_QLLT_DATA_LOADING: {
            return {
                ...state,
                queries: {
                    ...state.queries,
                    getQlltData: {
                        loading: action.payload,
                        error: null,
                    },
                },
            }
        }
        case SET_QLLT_DATA_FAILURE: {
            return {
                ...state,
                queries: {
                    ...state.queries,
                    getQlltData: {
                        loading: false,
                        error: action.payload,
                    },
                },
            }
        }
        case SET_QLLT_DATA: {
            return {
                ...state,
                queries: {
                    ...state.queries,
                    getQlltData: {
                        loading: false,
                        error: null,
                    },
                },
                data: action.payload,
            }
        }
        case SET_COST_AND_LEAD_TIME_LOADING: {
            return {
                ...state,
                queries: {
                    ...state.queries,
                    getCostAndLeadTime: {
                        loading: action.payload,
                        error: null,
                    },
                },
            }
        }
        case SET_COST_AND_LEAD_TIME_FAILURE: {
            return {
                ...state,
                queries: {
                    ...state.queries,
                    getCostAndLeadTime: {
                        loading: false,
                        error: action.payload,
                    },
                },
            }
        }
        case SET_COST_AND_LEAD_TIME: {
            return {
                ...state,
                queries: {
                    ...state.queries,
                    getCostAndLeadTime: {
                        loading: false,
                        error: null,
                    },
                },
                costAndLeadTimeData: action.payload,
            }
        }
        case GET_ALL_BATCH_POST_PROCESS_QUERY_DATA: {
            return {
                ...state,
                queries: {
                    ...state.queries,
                    getAllBatchPostProcessIdQueryData: {
                        loading: false,
                        error: null,
                    },
                },
                batchPostProcessIds: action.payload,
            }
        }
        case SET_ALL_BATCH_POST_PROCESS_LOADING: {
            return {
                ...state,
                queries: {
                    ...state.queries,
                    getAllBatchPostProcessIdQueryData: {
                        loading: action.payload,
                        error: null,
                    },
                },
            }
        }
        case GET_ALL_BATCH_POST_PROCESS_FAILURE: {
            return {
                ...state,
                queries: {
                    ...state.queries,
                    getAllBatchPostProcessIdQueryData: {
                        loading: false,
                        error: action.payload,
                    },
                },
            }
        }
        case SET_QLLT_CONFIGURE_OPTION: {
            return {
                ...state,
                configureLeadTimeOption: action.payload,
            }
        }

        case SET_PROCESS_CONFIG_TO_QMR: {
            return {
                ...state,
                processConfig: {
                    ...state.processConfig,
                    ...action.payload,
                },
            }
        }
        case UPDATE_PROCESS_CONFIG_DATA: {
            return {
                ...state,
                processConfig: {
                    ...state.processConfig,
                    ...action.payload,
                },
                queries: {
                    ...state.queries,
                    updateProcessConfigs: {
                        loading: false,
                        error: null,
                    },
                },
            }
        }
        case SET_PROCESS_DETAILS_LOADING: {
            return {
                ...state,
                queries: {
                    ...state.queries,
                    updateProcessConfigs: {
                        loading: action.payload,
                        error: null,
                    },
                },
            }
        }
        case GET_PROCESS_DETAILS_FAILURE: {
            return {
                ...state,
                queries: {
                    ...state.queries,
                    updateProcessConfigs: {
                        loading: false,
                        error: action.payload,
                    },
                },
            }
        }
        case RESET_OPTIMIZATION: {
            return {
                ...INIT_STATE,
                businessAccountCLTFeature: state.businessAccountCLTFeature,
            }
        }
        case GET_QLLT_SLACK_THREAD_QUERY_SUCCESS: {
            return {
                ...state,
                queries: {
                    ...state.queries,
                    getQlltSlackThreadData: {
                        loading: false,
                        error: null,
                    },
                },
                slackThreadUrl: action.payload,
            }
        }
        case GET_QLLT_SLACK_THREAD_QUERY_FAILURE: {
            return {
                ...state,
                queries: {
                    ...state.queries,
                    getQlltSlackThreadData: {
                        loading: false,
                        error: action.payload,
                    },
                },
            }
        }
        case GET_QLLT_SLACK_THREAD_QUERY_LOADING: {
            return {
                ...state,
                queries: {
                    ...state.queries,
                    getQlltSlackThreadData: {
                        loading: action.payload,
                        error: null,
                    },
                },
            }
        }
        case CREATE_SLACK_THREAD_LOADING: {
            return {
                ...state,
                queries: {
                    ...state.queries,
                    createSlackThread: {
                        loading: action.payload,
                        error: null,
                    },
                },
            }
        }
        case CREATE_SLACK_THREAD_FAILURE: {
            return {
                ...state,
                queries: {
                    ...state.queries,
                    createSlackThread: {
                        loading: false,
                        error: action.payload,
                    },
                },
            }
        }
        case REMOVE_ALL_THREADS_LOADING: {
            return {
                ...state,
                queries: {
                    ...state.queries,
                    removeAllThreads: {
                        loading: action.payload,
                        error: null,
                    },
                },
            }
        }
        case REMOVE_ALL_THREADS_FAILURE: {
            return {
                ...state,
                queries: {
                    ...state.queries,
                    removeAllThreads: {
                        loading: false,
                        error: action.payload,
                    },
                },
            }
        }
        case GET_RECOMMENDED_QUANTITY_TO_REDUCE_LEAD_TIME_LOADING: {
            return {
                ...state,
                queries: {
                    ...state.queries,
                    recommendedQuantitiesToHitDeliveryDate: {
                        loading: true,
                        error: null,
                    },
                },
            }
        }
        case GET_RECOMMENDED_QUANTITY_TO_REDUCE_LEAD_TIME_FAILURE: {
            return {
                ...state,
                queries: {
                    ...state.queries,
                    recommendedQuantitiesToHitDeliveryDate: {
                        loading: false,
                        error: action.payload,
                    },
                },
            }
        }
        case SET_RECOMMENDED_QUANTITY_TO_REDUCE_LEAD_TIME: {
            return {
                ...state,
                queries: {
                    ...state.queries,
                    recommendedQuantitiesToHitDeliveryDate: {
                        loading: false,
                        error: null,
                    },
                },
                recommendedQuantitiesToHitDeliveryDate: action.payload,
            }
        }
        case BUSINESS_ACCOUNT_FEATURE_QUERY_LOADING: {
            return {
                ...state,
                queries: {
                    ...state.queries,
                    getBusinessAccountFeature: {
                        loading: action.payload,
                        error: null,
                    },
                },
            }
        }
        case BUSINESS_ACCOUNT_FEATURE_QUERY_FAILURE: {
            return {
                ...state,
                queries: {
                    ...state.queries,
                    getBusinessAccountFeature: {
                        loading: false,
                        error: action.payload,
                    },
                },
            }
        }
        case BUSINESS_ACCOUNT_FEATURE_QUERY_SUCCESS: {
            return {
                ...state,
                queries: {
                    ...state.queries,
                    getBusinessAccountFeature: {
                        loading: false,
                        error: null,
                    },
                },
                businessAccountCLTFeature: action.payload,
            }
        }
        case SET_BUSINESS_ACCOUNT_FEATURE_LOADING: {
            return {
                ...state,
                queries: {
                    ...state.queries,
                    setCLTBusinessAccountFeature: {
                        loading: action.payload,
                        error: null,
                    },
                },
            }
        }
        case SET_BUSINESS_ACCOUNT_FEATURE_FAILURE: {
            return {
                ...state,
                queries: {
                    ...state.queries,
                    setCLTBusinessAccountFeature: {
                        loading: false,
                        error: action.payload,
                    },
                },
            }
        }
        case SET_LAST_ACTION_PERFORMED: {
            return {
                ...state,
                lastActivityPerformed: {
                    operation: action.payload.operation,
                    description: action.payload.description,
                    affectedQmrIds: action.payload.affectedQmrIds,
                },
            }
        }
        case RESET_LAST_ACTION_PERFORMED: {
            return {
                ...state,
                lastActivityPerformed: null,
            }
        }
        case SET_3D_MODE: {
            return {
                ...state,
                showConfigIn3D: action.payload,
            }
        }
        case SET_QLLT_SELECTED_OPTION: {
            return {
                ...state,
                qlltSelectedOption: action.payload,
            }
        }
        default:
            return state
    }
}

export default reducer
